import { JSON_LD_TYPES } from 'constants/index';
import JsonLD from './JsonLD';

export { JSON_LD_TYPES };
export default JsonLD;
